<div class="swiper-container" #swiper>
    <div class="swiper-wrapper">
        <div *ngFor="let image of img" class="swiper-slide" [style.height]="item.height"
            [style.width]="item.customField25" [ngStyle.lt-md]="{
        'height': item.heightMob, 'width':item.customField26
      }" >
      <div class="quote-box" [style.background-color]="item.customField8">
        <mat-icon class="quote-icon">format_quote</mat-icon>
        <p class="quote-text"   [style.color]="item.customField5" >
          <calsoft-editor-text [data]="data" [text]="image.customField21"></calsoft-editor-text> 
        </p>
      </div>

      <div  fxLayout="column" fxLayoutAlign="space-around center">
        <img [src]="bannerServerPath+image.img" alt="Samsung Next Logo" class="logo" />
    
        <h3 class="company-name"  [style.color]="item.customField5">
          <calsoft-editor-text [data]="data" [text]="image.customField20"></calsoft-editor-text> 
        </h3>
      </div>
    
     
        </div>
    </div>
    <!-- <div class="swiper-pagination"></div>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div> -->

    <div class="custom-nav" fxShow fxHide.lt-md>
        <div class="owl-prev" (click)="navigateSwiper('prev')" *ngIf="swiper">
          <mat-icon class="custom-icon primary-icon">arrow_back</mat-icon>
        </div>
        <div class="owl-next" (click)="navigateSwiper('next')" *ngIf="swiper">
          <mat-icon class="custom-icon primary-icon">arrow_forward</mat-icon>
        </div>
      </div>
</div>

